export const CurriculoEscolar = {
    
}